import { render, staticRenderFns } from "./TextRecord.vue?vue&type=template&id=464adb07"
import script from "./TextRecord.vue?vue&type=script&lang=js"
export * from "./TextRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports